import * as React from 'react';
import { FC } from 'react';

import { useIntl } from 'react-intl';

import { IMobileOrderingTextProps } from './types';

export const MobileOrderingText: FC<IMobileOrderingTextProps> = ({
  isLoggedIn,
  isMobileAvailable,
}) => {
  const { formatMessage } = useIntl();

  return (
    <>
      {isMobileAvailable
        ? formatMessage(isLoggedIn ? { id: 'addMobileOrder' } : { id: 'logInToRedeemOnline' })
        : formatMessage({ id: 'mobileOrderingComingSoon' })}
    </>
  );
};
